(() => {
  if (window.tshJumpPilotLoaded) return;
  window.tshJumpPilotLoaded = true;
  function init(scope = document) {
    scope.querySelectorAll('[data-jump-navigation]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      // Dialog focus can inherit keyboard modality when an already-focused trigger
      // is tapped. Suppress that pointer-only ring without blurring the control.
      root.addEventListener('pointerdown', () => { root.dataset.pointerFocus = 'true'; });
      const trigger = root.querySelector('[data-jump-open]');
      const dialog = root.querySelector('dialog');
      if (!dialog?.showModal) return;
      root.classList.add('is-enhanced');
      trigger.hidden = false;
      let previousOverflow = '';
      function close() { dialog.close(); }
      function unlock() {
        document.documentElement.style.overflow = previousOverflow;
        trigger.setAttribute('aria-expanded', 'false');
      }
      trigger.addEventListener('click', () => {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[aria-current]')?.focus({preventScroll:true});
      });
      dialog.querySelector('[data-jump-close]').addEventListener('click', close);
      dialog.addEventListener('close', () => { unlock(); trigger.focus({preventScroll:true}); });
      dialog.addEventListener('click', e => {
        if (e.target.closest('a')) close();
        if (e.target === dialog) {
          const r=dialog.getBoundingClientRect();
          if(e.clientY<r.top || e.clientY>r.bottom) close();
        }
      });
      window.addEventListener('pagehide', () => { if(dialog.open) close(); });
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { if(dialog.open) close(); });
      // Preserve old menu/bookmark hashes by resolving them to native collection URLs.
      if (location.pathname === root.dataset.jumpParent && location.hash) {
        // Compatibility only: newly added categories use native menu URLs and need no code.
        const aliases = {'ropeless':'jump-ropeless','rope-handles-accessories':'jump-rope-handles-accessories','light-ropes':'flow-ropes','kettlebells-sandbags-rucking':'kettlebells-sandbags','training-sleds':'sleds','learn-to-jump-again':'jump-ropes','recovery-tools':'soft-tissue-recovery'};
        const hash=decodeURIComponent(location.hash.slice(1));
        const handle=aliases[hash] || hash;
        const link=handle && [...root.querySelectorAll('.tsh-jump-links a')].find(a=>new URL(a.href).pathname==='/collections/'+handle);
        if(link && new URL(link.href).pathname !== location.pathname) { const target=new URL(link.href);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)target.searchParams.set('preview_theme_id',preview);location.replace(target.href); }
      }
    });
  }
  init();
  document.addEventListener('keydown', () => {
    document.querySelectorAll('[data-jump-navigation][data-pointer-focus]').forEach(root => {
      delete root.dataset.pointerFocus;
    });
  }, true);
  document.addEventListener('shopify:section:load', e=>init(e.target));
})();
